(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-before-after-image"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;

class BeforeAfterImageSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.onMount();
  }

  onMount() {
    this.compareWrapper = this.$root.querySelector('.pxu-before-after-image__compare-wrapper');
    this.cursor = this.$root.querySelector('.pxu-before-after-image__cursor');
    
    if (this.compareWrapper && this.cursor) {
      this.initEventListeners();
      this.initIntersectionObserver();
    }
  }

  onUnmount() {
    this.events.unregisterAll();
  }

  initIntersectionObserver() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            observer.unobserve(this.compareWrapper);
            this.animateInitialPosition();
          }
        });
      },
      {
        rootMargin: '0px',
        threshold: 0.33
      }
    );

    observer.observe(this.compareWrapper);
  }

  initEventListeners() {
    this.events.register(this.compareWrapper, 'pointerdown', this.handlePointerDown.bind(this));
    this.events.register(this.compareWrapper, 'gotpointercapture', (e) => {
      this.compareWrapper.setPointerCapture(e.pointerId);
    });

    this.events.register(this.cursor, 'keydown', this.handleKeyboardNav.bind(this));

    this.events.register(this.compareWrapper, 'touchstart', (e) => {
      if (e.target === this.cursor || this.cursor.contains(e.target)) {
        e.preventDefault();
      }
    }, { passive: false });
  }

  handlePointerDown(event) {
    if (event.target.tagName === 'A') return;

    event.preventDefault();
    
    const isMobile = window.matchMedia('(max-width: 859px)').matches;
    const isTouch = event.pointerType === 'touch';
    const isOnCursor = event.target === this.cursor || this.cursor.contains(event.target);
    
    if (isMobile && isTouch && !isOnCursor) {
      return;
    }
    
    this.isDragging = true;
    this.compareWrapper.setPointerCapture(event.pointerId);
    
    const handlePointerMove = (e) => {
      if (!this.isDragging || e.buttons === 0) {
        this.events.unregister(this.compareWrapper, 'pointermove', handlePointerMove);
        return;
      }
      
      if (isMobile && isTouch && !isOnCursor) {
        return;
      }
      
      this.updateSliderPosition(e);
    };
    
    this.events.register(this.compareWrapper, 'pointermove', handlePointerMove);
    this.events.register(this.compareWrapper, 'pointerup', () => {
      this.isDragging = false;
      this.events.unregister(this.compareWrapper, 'pointermove', handlePointerMove);
    }, { once: true });
    
    if (!isMobile || !isTouch || isOnCursor) {
      this.updateSliderPosition(event);
    }
  }

  handleKeyboardNav(event) {
    const isVertical = this.compareWrapper.hasAttribute('data-vertical');
    const isValidKey = isVertical 
      ? ['ArrowUp', 'ArrowDown'].includes(event.code)
      : ['ArrowLeft', 'ArrowRight'].includes(event.code);
    
    if (!this.cursor.contains(event.target) || !isValidKey) return;

    event.preventDefault();
    
    const currentPosition = this.getCurrentPosition();
    const step = 1;
    const isDecreasing = isVertical ? event.code === 'ArrowUp' : event.code === 'ArrowLeft';
    
    this.updatePosition(currentPosition + (isDecreasing ? -step : step));
  }

  getCurrentPosition() {
    const position = parseFloat(getComputedStyle(this.compareWrapper).getPropertyValue('--before-after-cursor-position'));
    return isNaN(position) 
      ? parseFloat(getComputedStyle(this.$root).getPropertyValue('--before-after-initial-cursor-position'))
      : position;
  }

  updateSliderPosition(event) {
    const rect = this.compareWrapper.getBoundingClientRect();
    const isVertical = this.compareWrapper.hasAttribute('data-vertical');
    
    const percentage = isVertical
      ? ((event.clientY - rect.top) / rect.height) * 100
      : ((event.clientX - rect.left) / rect.width) * 100;

    this.updatePosition(document.dir === 'rtl' ? 100 - percentage : percentage);
  }

  updatePosition(percentage) {
    const boundedPercentage = Math.min(Math.max(percentage, 0), 100);
    this.compareWrapper.style.setProperty('--before-after-cursor-position', `${boundedPercentage}%`);
  }

  animateInitialPosition() {
    this.compareWrapper.style.setProperty('--before-after-cursor-position', '0%');
    
    setTimeout(() => {
      const startPosition = 0;
      const endPosition = parseFloat(getComputedStyle(this.$root).getPropertyValue('--before-after-initial-cursor-position'));
      const duration = 500;
      const startTime = performance.now();

      const animate = (currentTime) => {
        const progress = Math.min((currentTime - startTime) / duration, 1);
        const easeProgress = 1 - Math.pow(1 - progress, 2);
        
        this.updatePosition(startPosition + (endPosition - startPosition) * easeProgress);

        if (progress < 1) requestAnimationFrame(animate);
      };

      requestAnimationFrame(animate);
    }, 100);
  }
}

document.querySelectorAll('[data-pxu-before-after-image]').forEach(($section) => {
  Section.init($section, BeforeAfterImageSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.BeforeAfterImageSection = BeforeAfterImageSection;
}
  } catch(e) { console.error(e); }
})();
})();
